import Navbar from 'react-bootstrap/Navbar'
import Dropdown from 'react-bootstrap/Dropdown';
import Nav from 'react-bootstrap/Nav'
import NavItem from 'react-bootstrap/NavItem';
import NavLink from 'react-bootstrap/NavLink';
import { useTranslation } from 'react-i18next';
//import { Link } from 'react-router';
import { changeCurrency, setModalShow } from '../../stores/user/userSlice';
import { useAppDispatch, useAppSelector } from '../../services/hooks';
import changeLangURL from '../../services/changeLangURL';
import { Link } from 'react-router';
import { generateUrl } from "../../helpers/routeHelper.ts";

export default function HeaderMenu() {
    const { t, i18n } = useTranslation();
    const user = useAppSelector((state) => state.user.email);
    const currency = useAppSelector((state) => state.user.currency);
    //const reseller = useAppSelector((state) => state.user.reseller);
    const dispatch = useAppDispatch();

    return (
        <Navbar.Collapse id="navbarSupportedContent">
            <Nav className='me-auto ps-4 ps-xl-0 pt-1'>
                {/* <li className="nav-item list-group-item">
                <a className="nav-link" href="https://trial.romer.com.pl/lang-pl/category-map">Mapa kategorii</a>
                </li> */}
                <Dropdown as={NavItem}>
                    <Dropdown.Toggle as={NavLink}>{t('header.menu.about.name')}</Dropdown.Toggle>
                    <Dropdown.Menu className='rounded-3'>
                        <Dropdown.Item as={"div"}>
                            {/* <Link to={'/statute'}>{t('menu.about.statute')}</Link> */}
                            <Link to={'/regulamin'}>{t('header.menu.about.rules')}</Link>
                        </Dropdown.Item>
                        <Dropdown.Item href='/downloads/polityka_prywatnosci_pl.pdf'>
                            {/* <Link to={'/privacy'}>{t('menu.about.privacy')}</Link> */}
                            {t('header.menu.about.privacy')}
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
                <Nav.Item>
                    <Nav.Link href={generateUrl('contact', i18n.language)}>
                        {/* <Link to={'/contact'}>{t('menu.contact')}</Link> */}
                        {t('header.menu.contact')}
                    </Nav.Link>
                </Nav.Item>
                <Nav.Item>
                    <Nav.Link href='https://www.facebook.com/romerpp/' className='bi-facebook text-success'>
                        <small className='d-xl-none'>&nbsp;Facebook</small>
                    </Nav.Link>
                </Nav.Item>
                <Dropdown as={NavItem}>
                    <Dropdown.Toggle as={NavLink} className='bi-currency-exchange text-success'
                                     /*disabled={Boolean(reseller)}*/>
                        <small
                            className="small d-xl-none d-xxl-inline">&nbsp;{t('header.menu.currency')} - {currency}</small>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='rounded-3'>
                        <CurrencyItem currency='PLN' description='PLN - Polish Zloty' />
                        <CurrencyItem currency='USD' description='USD - US Dollar' />
                        <CurrencyItem currency='EUR' description='EUR - Euro' />
                    </Dropdown.Menu>
                </Dropdown>
                <Dropdown as={NavItem} className='jezyk'>
                    <Dropdown.Toggle as={NavLink} className='bi-translate text-success'>
                        <small className="small d-xl-none d-xxl-inline" id="d">&nbsp;{t('header.menu.lang')}</small>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className='rounded-3'>
                        <LangItem targetLang={"en"} lang={"English"} />
                        <LangItem targetLang={"pl"} lang={"Polski"} />
                        <LangItem targetLang={"de"} lang={"Deutsch"} />
                        {/*<LangItem targetLang={"it"} lang={"Italiano"}/>
                        <LangItem targetLang={"cz"} lang={"Czech"}/>
                        <LangItem targetLang={"es"} lang={"Spanish"}/>
                        <LangItem targetLang={"fr"} lang={"French"}/>
                        <LangItem targetLang={"nl"} lang={"Dutch"}/>
                        <LangItem targetLang={"no"} lang={"Norsk"}/>
                        <LangItem targetLang={"pt"} lang={"Portugal"}/>
                        <LangItem targetLang={"hu"} lang={"Hungary"}/>*/}
                    </Dropdown.Menu>
                </Dropdown>
                <Nav.Item>
                    <Nav.Link onClick={() => dispatch(setModalShow(true))}
                        className='rounded-2 bi bi-person-circle d-xl-none text-success'>
                        <small className="small">
                            &nbsp;{user ? user : t('header.menu.login')}
                        </small>
                    </Nav.Link>
                </Nav.Item>
            </Nav>
        </Navbar.Collapse>
    )
}

function LangItem({ targetLang, lang }: { targetLang: string, lang: string }) {
    return (
        <Dropdown.Item onClick={() => changeLangURL(targetLang)}>
            {lang}
        </Dropdown.Item>
    )
}

function CurrencyItem({ currency, description }: { currency: string, description: string }) {
    const dispatch = useAppDispatch()
    return (
        <Dropdown.Item onClick={async () => {
            await dispatch(changeCurrency(currency));
            window.location.reload();
        }}>{description}</Dropdown.Item>
    )
}